module.exports = __webpack_public_path__ + "static/img/03.831c856.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/03.jpg
// module id = ZT4i
// module chunks = 0